import React from 'react';
import LegalPageTemplate from './LegalPageTemplate';

const Disclaimer = () => {
  return (
    <LegalPageTemplate 
      title="Disclaimer"
    >
      <div className="prose prose-lg max-w-none">
        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p className="text-lg">
            The content included on this website is for indicative purposes only and is not intended to constitute specialist or personal advice. This website cannot provide a complete statement of all information without consideration of your financial and other requirements and objectives and your complete financial situation. We recommend that you have personal contact with the team at Aircash Finance or Strawberry Loans Pty Ltd before taking any credit action.
          </p>

          <div className="bg-primary/5 border-l-4 border-primary p-6 rounded-r-xl my-8">
            <p className="text-lg font-medium text-primary mb-2">Important Notice</p>
            <p className="text-gray-700">
              Credit law demands that all loan applications must be subjected to a responsible lending assessment to establish whether the loan would be not unsuitable and this assessment is undertaken by representatives from Strawberry Loans.
            </p>
          </div>
        </div>
      </div>
    </LegalPageTemplate>
  );
};

export default Disclaimer; 